import { default as aboutKHeoDqI3kzMeta } from "C:/project/akhtar-pub/pages/about.vue?macro=true";
import { default as cartU5mGFT0pyqMeta } from "C:/project/akhtar-pub/pages/cart.vue?macro=true";
import { default as checkoutxiUgtdYGfrMeta } from "C:/project/akhtar-pub/pages/checkout.vue?macro=true";
import { default as coming_45soonjzTUWaPpGPMeta } from "C:/project/akhtar-pub/pages/coming-soon.vue?macro=true";
import { default as contactQo1aLVzAatMeta } from "C:/project/akhtar-pub/pages/contact.vue?macro=true";
import { default as detailsXPy0GCXdmPMeta } from "C:/project/akhtar-pub/pages/details.vue?macro=true";
import { default as indexL0XRcXEwYYMeta } from "C:/project/akhtar-pub/pages/index.vue?macro=true";
import { default as new_45arrivalXqQd5bXCJkMeta } from "C:/project/akhtar-pub/pages/new-arrival.vue?macro=true";
import { default as ordersCKQFgeZL1ZMeta } from "C:/project/akhtar-pub/pages/orders.vue?macro=true";
import { default as outletsgImznqsuo4Meta } from "C:/project/akhtar-pub/pages/outlets.vue?macro=true";
import { default as cancelmrYUaWD90oMeta } from "C:/project/akhtar-pub/pages/payments/response/cancel.vue?macro=true";
import { default as failedZeasRjNxthMeta } from "C:/project/akhtar-pub/pages/payments/response/failed.vue?macro=true";
import { default as later2U87M8aw3DMeta } from "C:/project/akhtar-pub/pages/payments/response/later.vue?macro=true";
import { default as successoCJhyA1gqLMeta } from "C:/project/akhtar-pub/pages/payments/response/success.vue?macro=true";
import { default as privacy_45policyko5ocBJK9BMeta } from "C:/project/akhtar-pub/pages/privacy-policy.vue?macro=true";
import { default as profiley8XuAxanY9Meta } from "C:/project/akhtar-pub/pages/profile.vue?macro=true";
import { default as returnKwDqLIb6n6Meta } from "C:/project/akhtar-pub/pages/return.vue?macro=true";
import { default as salesr7tXKScEc8Meta } from "C:/project/akhtar-pub/pages/sales.vue?macro=true";
import { default as shop_32copyA43gOk09IAMeta } from "C:/project/akhtar-pub/pages/shop copy.vue?macro=true";
import { default as shopkxABkBGz47Meta } from "C:/project/akhtar-pub/pages/shop.vue?macro=true";
import { default as sofa_453dPkUYtliPYyMeta } from "C:/project/akhtar-pub/pages/sofa-3d.vue?macro=true";
import { default as terms_45conditionsUVuU3FEq4tMeta } from "C:/project/akhtar-pub/pages/terms-conditions.vue?macro=true";
export default [
  {
    name: aboutKHeoDqI3kzMeta?.name ?? "about",
    path: aboutKHeoDqI3kzMeta?.path ?? "/about",
    meta: aboutKHeoDqI3kzMeta || {},
    alias: aboutKHeoDqI3kzMeta?.alias || [],
    redirect: aboutKHeoDqI3kzMeta?.redirect || undefined,
    component: () => import("C:/project/akhtar-pub/pages/about.vue").then(m => m.default || m)
  },
  {
    name: cartU5mGFT0pyqMeta?.name ?? "cart",
    path: cartU5mGFT0pyqMeta?.path ?? "/cart",
    meta: cartU5mGFT0pyqMeta || {},
    alias: cartU5mGFT0pyqMeta?.alias || [],
    redirect: cartU5mGFT0pyqMeta?.redirect || undefined,
    component: () => import("C:/project/akhtar-pub/pages/cart.vue").then(m => m.default || m)
  },
  {
    name: checkoutxiUgtdYGfrMeta?.name ?? "checkout",
    path: checkoutxiUgtdYGfrMeta?.path ?? "/checkout",
    meta: checkoutxiUgtdYGfrMeta || {},
    alias: checkoutxiUgtdYGfrMeta?.alias || [],
    redirect: checkoutxiUgtdYGfrMeta?.redirect || undefined,
    component: () => import("C:/project/akhtar-pub/pages/checkout.vue").then(m => m.default || m)
  },
  {
    name: coming_45soonjzTUWaPpGPMeta?.name ?? "coming-soon",
    path: coming_45soonjzTUWaPpGPMeta?.path ?? "/coming-soon",
    meta: coming_45soonjzTUWaPpGPMeta || {},
    alias: coming_45soonjzTUWaPpGPMeta?.alias || [],
    redirect: coming_45soonjzTUWaPpGPMeta?.redirect || undefined,
    component: () => import("C:/project/akhtar-pub/pages/coming-soon.vue").then(m => m.default || m)
  },
  {
    name: contactQo1aLVzAatMeta?.name ?? "contact",
    path: contactQo1aLVzAatMeta?.path ?? "/contact",
    meta: contactQo1aLVzAatMeta || {},
    alias: contactQo1aLVzAatMeta?.alias || [],
    redirect: contactQo1aLVzAatMeta?.redirect || undefined,
    component: () => import("C:/project/akhtar-pub/pages/contact.vue").then(m => m.default || m)
  },
  {
    name: detailsXPy0GCXdmPMeta?.name ?? "details",
    path: detailsXPy0GCXdmPMeta?.path ?? "/details",
    meta: detailsXPy0GCXdmPMeta || {},
    alias: detailsXPy0GCXdmPMeta?.alias || [],
    redirect: detailsXPy0GCXdmPMeta?.redirect || undefined,
    component: () => import("C:/project/akhtar-pub/pages/details.vue").then(m => m.default || m)
  },
  {
    name: indexL0XRcXEwYYMeta?.name ?? "index",
    path: indexL0XRcXEwYYMeta?.path ?? "/",
    meta: indexL0XRcXEwYYMeta || {},
    alias: indexL0XRcXEwYYMeta?.alias || [],
    redirect: indexL0XRcXEwYYMeta?.redirect || undefined,
    component: () => import("C:/project/akhtar-pub/pages/index.vue").then(m => m.default || m)
  },
  {
    name: new_45arrivalXqQd5bXCJkMeta?.name ?? "new-arrival",
    path: new_45arrivalXqQd5bXCJkMeta?.path ?? "/new-arrival",
    meta: new_45arrivalXqQd5bXCJkMeta || {},
    alias: new_45arrivalXqQd5bXCJkMeta?.alias || [],
    redirect: new_45arrivalXqQd5bXCJkMeta?.redirect || undefined,
    component: () => import("C:/project/akhtar-pub/pages/new-arrival.vue").then(m => m.default || m)
  },
  {
    name: ordersCKQFgeZL1ZMeta?.name ?? "orders",
    path: ordersCKQFgeZL1ZMeta?.path ?? "/orders",
    meta: ordersCKQFgeZL1ZMeta || {},
    alias: ordersCKQFgeZL1ZMeta?.alias || [],
    redirect: ordersCKQFgeZL1ZMeta?.redirect || undefined,
    component: () => import("C:/project/akhtar-pub/pages/orders.vue").then(m => m.default || m)
  },
  {
    name: outletsgImznqsuo4Meta?.name ?? "outlets",
    path: outletsgImznqsuo4Meta?.path ?? "/outlets",
    meta: outletsgImznqsuo4Meta || {},
    alias: outletsgImznqsuo4Meta?.alias || [],
    redirect: outletsgImznqsuo4Meta?.redirect || undefined,
    component: () => import("C:/project/akhtar-pub/pages/outlets.vue").then(m => m.default || m)
  },
  {
    name: cancelmrYUaWD90oMeta?.name ?? "payments-response-cancel",
    path: cancelmrYUaWD90oMeta?.path ?? "/payments/response/cancel",
    meta: cancelmrYUaWD90oMeta || {},
    alias: cancelmrYUaWD90oMeta?.alias || [],
    redirect: cancelmrYUaWD90oMeta?.redirect || undefined,
    component: () => import("C:/project/akhtar-pub/pages/payments/response/cancel.vue").then(m => m.default || m)
  },
  {
    name: failedZeasRjNxthMeta?.name ?? "payments-response-failed",
    path: failedZeasRjNxthMeta?.path ?? "/payments/response/failed",
    meta: failedZeasRjNxthMeta || {},
    alias: failedZeasRjNxthMeta?.alias || [],
    redirect: failedZeasRjNxthMeta?.redirect || undefined,
    component: () => import("C:/project/akhtar-pub/pages/payments/response/failed.vue").then(m => m.default || m)
  },
  {
    name: later2U87M8aw3DMeta?.name ?? "payments-response-later",
    path: later2U87M8aw3DMeta?.path ?? "/payments/response/later",
    meta: later2U87M8aw3DMeta || {},
    alias: later2U87M8aw3DMeta?.alias || [],
    redirect: later2U87M8aw3DMeta?.redirect || undefined,
    component: () => import("C:/project/akhtar-pub/pages/payments/response/later.vue").then(m => m.default || m)
  },
  {
    name: successoCJhyA1gqLMeta?.name ?? "payments-response-success",
    path: successoCJhyA1gqLMeta?.path ?? "/payments/response/success",
    meta: successoCJhyA1gqLMeta || {},
    alias: successoCJhyA1gqLMeta?.alias || [],
    redirect: successoCJhyA1gqLMeta?.redirect || undefined,
    component: () => import("C:/project/akhtar-pub/pages/payments/response/success.vue").then(m => m.default || m)
  },
  {
    name: privacy_45policyko5ocBJK9BMeta?.name ?? "privacy-policy",
    path: privacy_45policyko5ocBJK9BMeta?.path ?? "/privacy-policy",
    meta: privacy_45policyko5ocBJK9BMeta || {},
    alias: privacy_45policyko5ocBJK9BMeta?.alias || [],
    redirect: privacy_45policyko5ocBJK9BMeta?.redirect || undefined,
    component: () => import("C:/project/akhtar-pub/pages/privacy-policy.vue").then(m => m.default || m)
  },
  {
    name: profiley8XuAxanY9Meta?.name ?? "profile",
    path: profiley8XuAxanY9Meta?.path ?? "/profile",
    meta: profiley8XuAxanY9Meta || {},
    alias: profiley8XuAxanY9Meta?.alias || [],
    redirect: profiley8XuAxanY9Meta?.redirect || undefined,
    component: () => import("C:/project/akhtar-pub/pages/profile.vue").then(m => m.default || m)
  },
  {
    name: returnKwDqLIb6n6Meta?.name ?? "return",
    path: returnKwDqLIb6n6Meta?.path ?? "/return",
    meta: returnKwDqLIb6n6Meta || {},
    alias: returnKwDqLIb6n6Meta?.alias || [],
    redirect: returnKwDqLIb6n6Meta?.redirect || undefined,
    component: () => import("C:/project/akhtar-pub/pages/return.vue").then(m => m.default || m)
  },
  {
    name: salesr7tXKScEc8Meta?.name ?? "sales",
    path: salesr7tXKScEc8Meta?.path ?? "/sales",
    meta: salesr7tXKScEc8Meta || {},
    alias: salesr7tXKScEc8Meta?.alias || [],
    redirect: salesr7tXKScEc8Meta?.redirect || undefined,
    component: () => import("C:/project/akhtar-pub/pages/sales.vue").then(m => m.default || m)
  },
  {
    name: shop_32copyA43gOk09IAMeta?.name ?? "shop copy",
    path: shop_32copyA43gOk09IAMeta?.path ?? "/shop%20copy",
    meta: shop_32copyA43gOk09IAMeta || {},
    alias: shop_32copyA43gOk09IAMeta?.alias || [],
    redirect: shop_32copyA43gOk09IAMeta?.redirect || undefined,
    component: () => import("C:/project/akhtar-pub/pages/shop copy.vue").then(m => m.default || m)
  },
  {
    name: shopkxABkBGz47Meta?.name ?? "shop",
    path: shopkxABkBGz47Meta?.path ?? "/shop",
    meta: shopkxABkBGz47Meta || {},
    alias: shopkxABkBGz47Meta?.alias || [],
    redirect: shopkxABkBGz47Meta?.redirect || undefined,
    component: () => import("C:/project/akhtar-pub/pages/shop.vue").then(m => m.default || m)
  },
  {
    name: sofa_453dPkUYtliPYyMeta?.name ?? "sofa-3d",
    path: sofa_453dPkUYtliPYyMeta?.path ?? "/sofa-3d",
    meta: sofa_453dPkUYtliPYyMeta || {},
    alias: sofa_453dPkUYtliPYyMeta?.alias || [],
    redirect: sofa_453dPkUYtliPYyMeta?.redirect || undefined,
    component: () => import("C:/project/akhtar-pub/pages/sofa-3d.vue").then(m => m.default || m)
  },
  {
    name: terms_45conditionsUVuU3FEq4tMeta?.name ?? "terms-conditions",
    path: terms_45conditionsUVuU3FEq4tMeta?.path ?? "/terms-conditions",
    meta: terms_45conditionsUVuU3FEq4tMeta || {},
    alias: terms_45conditionsUVuU3FEq4tMeta?.alias || [],
    redirect: terms_45conditionsUVuU3FEq4tMeta?.redirect || undefined,
    component: () => import("C:/project/akhtar-pub/pages/terms-conditions.vue").then(m => m.default || m)
  }
]